import { FC } from 'react';
import { useFormContext, useFieldArray, Controller } from 'react-hook-form';
// i18next
import { useTranslation } from 'react-i18next';
// Icons
import { FaTrash } from 'react-icons/fa';
// Components
import { Button, IconButton } from 'components/Buttons';
import { Tooltip } from 'components/Tooltip';
import Accordion from 'components/Accordion';
import { Input } from 'components/Controls';

const SectionPrizes:FC = () => {
  const { t } = useTranslation();

  const { control } = useFormContext();

  const { fields, append, remove } = useFieldArray({
    control,
    name: 'prizes'
  });

  const handleAdd = () => {
    append({ prize: '' });
  }

  return (
    <div react-scroll="prizes">
      <Accordion label={t('labels.prizes')} icon="cup">
        <div className="w-full">
          <div className="mb-4 text-right">
            <Button
              variant="outlined"
              onClick={handleAdd}
            >{t('buttons.addPrize')}</Button>
          </div>
          {fields.map((field, index) => (
            <div key={`prize-item-${field.id}`} className="flex items-end">
              <div className="flex-grow">
                <Controller
                  control={control} name={`prizes.${index}.prize`}
                  render={({ field: { value, onChange } }) => (
                    <Input
                      id={`prizes.${index}.prize`} name={`prizes.${index}.prize`}
                      label={`${t('labels.prize')} ${index + 1}`}
                      value={value}
                      onChange={onChange}
                    />
                  )}
                />
              </div>
              <div className="pl-2 pb-6">
                <Tooltip title={t('buttons.removePrize')}>
                  <IconButton
                    onClick={() => remove(index)}
                  ><FaTrash /></IconButton>
                </Tooltip>
              </div>
            </div>
          ))}
        </div>
      </Accordion>
    </div>
  )
}

export default SectionPrizes;
